'use client';

import Lottie, { type LottieRefCurrentProps } from 'lottie-react';
import { useEffect, useRef } from 'react';

import animationData from '../../../../../public/arbi.json';

export const LoadingScreen = () => {
  const lottieRef = useRef<LottieRefCurrentProps>(null);

  useEffect(() => {
    if (lottieRef.current) {
      lottieRef.current.setSpeed(1.8);
    }
  }, []);

  return (
    <div className="fixed inset-0 z-50 flex flex-col items-center justify-center bg-white">
      <div className="relative flex flex-col items-center">
        <div className="h-48 w-48">
          <Lottie
            lottieRef={lottieRef}
            animationData={animationData}
            loop={true}
            autoplay={true}
            style={{ width: '100%', height: '100%' }}
          />
        </div>

        <div className="mt-8 text-center">
          <h2 className="text-xl font-semibold text-gray-900">Carregando...</h2>
          <p className="mt-2 text-sm text-gray-600">Preparando o ambiente</p>
        </div>
      </div>
    </div>
  );
};
